<template>
  <div class="personnelList app-container">
    <template>
      <QueryForm
        ref="QueryForm"
        v-model="formInline"
        :class="{noPadding:layoutType===2}"
        :layout-type="layoutType"
        :agreement-code="agreementCode"
        @onSearch="getData"
      />
      <DataTable
        ref="table"
        :loading="tableLoading"
        :list="list"
        :table-height="tableHeight"
      />
      <BasePagination
        :total="total"
        :page-size="formInline.pageSize"
        :form="formInline"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </template>
  </div>
</template>

<script>
import QueryForm from './components/QueryForm.vue'
import DataTable from './components/Table.vue'
import { pageListByProject } from '@/api/log'
import mixins from '@/mixins/index'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  components: { QueryForm, DataTable },
  mixins: [mixins],
  props: {
    agreementCode: {
      type: String,
      default: ''
    },
    layoutType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      formInline: {
        pageSize: 20,
        pageNumber: 1,
        sourceName: '',
        logType: '',
        agreementCode: '',
        startTime: moment().subtract(7, 'd').format('YYYY-MM-DD 00:00:00'),
        endTime: moment().format('YYYY-MM-DD 00:00:00'),
        time: [moment().subtract(7, 'd').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 00:00:00')]
      },
      tableLoading: false,
      list: [],
      total: 0,
      addDialogVisible: false,
      formData: {},
      submitLoading: false,
      type: 1
    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem
    })
  },
  created() {
    if (this.agreementCode) {
      this.formInline.agreementCode = this.agreementCode
    }
    if (this.layoutType === 2) {
      this.minusHeight = 234
    }
    if (this.layoutType !== 2 && this.agreementCode) {
      this.minusHeight = 300
    }
  },
  mounted() {
    if (this.layoutType === 2) {
      this.getData()
    }
  },
  methods: {
    getData() {
      if (this.formInline.time) {
        this.formInline.startTime = this.formInline.time[0]
        this.formInline.endTime = this.formInline.time[1].split(' ')[0] + ' 23:59:59'
      } else {
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.tableLoading = true
      const form = { businessId: this.projectItem.projectId, ...this.formInline }
      if (this.agreementCode) {
        form.agreementCode = this.agreementCode
      }
      pageListByProject(form).then(res => {
        res.data.records.forEach(element => {
          element.editLoading = false
        })
        this.list = res.data.records
        this.total = res.data.total
        this.$refs.table.getInstance().bodyWrapper.scrollTop = 0
      }).finally(() => {
        this.tableLoading = false
      })
    },
    handleSizeChange(e) {
      this.formInline.pageSize = e
      this.getData()
    },
    handleCurrentChange(e) {
      this.formInline.pageNumber = e
      this.getData()
    }

  }
}
</script>

<style scoped>
.personnelList{
    background: #fff;
}
.noPadding{
  padding-top: 0;
}
</style>

